import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import FavoriteIcon from '@mui/icons-material/Favorite';
import NavigationIcon from '@mui/icons-material/Navigation';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Box": Box, "@mui/material/Fab": Fab, "@mui/icons-material/Add": AddIcon, "@mui/icons-material/Edit": EditIcon, "@mui/icons-material/Favorite": FavoriteIcon, "@mui/icons-material/Navigation": NavigationIcon } } });
export default ClientProvider;
